import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import { useEducation } from '../../context/educationContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import Modal from '../../components/modal';
import { toast } from 'react-toastify';
import PlusCircle from '../../assets/icons/pluscircle.svg';
import QuickAddModal from '../../components/modal/quickAddModal';
import useSubmitLock from '../../utils/useSubmitLock';


const Course = () => {
  const { listCourses, createCourse, listTypeCourses } = useEducation();
  const { listInstitutions, createInstitution } = useAuxiliaries();
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();
  const [courses, setCourses] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    modulo: '',
    duration: '',
    duration_hours: '',
    duration_minutes: '',
    ead: false,
    active: true,
    days: '',
    individual: false,
    shift: '',
    offeror: '',
    type_course: ''
  });

  const [typeCourses, setTypeCourses] = useState([]);
  const [institution, setInstitution] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await listCourses();
        setCourses(res.results || []);
      } catch (err) {
        console.error('Erro ao carregar cursos:', err);
      }
    };
    fetchCourses();
  }, [listCourses]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const typeRes = await listTypeCourses();
        setTypeCourses(typeRes?.results || []);
        const schoolRes = await listInstitutions();
        setInstitution(schoolRes?.results || []);
      } catch (err) {
        console.error('Erro ao carregar dados adicionais:', err);
      }
    };
    fetchData();
  }, [listTypeCourses, listInstitutions]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        const formattedDuration = `${String(formData.duration_hours || 0).padStart(2, '0')}:${String(formData.duration_minutes || 0).padStart(2, '0')}:00`;
        const payload = {
          ...formData,
          duration: formattedDuration,
        };
        delete payload.duration_hours;
        delete payload.duration_minutes;
        await createCourse(payload);
        setIsModalOpen(false);
        const updated = await listCourses();
        setCourses(updated.results || []);
        setFormData({
          name: '',
          modulo: '',
          duration: '',
          duration_hours: '',
          duration_minutes: '',
          ead: false,
          active: true,
          days: '',
          individual: false,
          shift: '',
          offeror: '',
          type_course: ''
        });
      } catch (err) {
        console.error('Erro ao cadastrar curso:', err);
        toast.error('Erro ao cadastrar curso');
      }
    });
  };


  const handleAddInstituition = async (institutionData) => {
    try {
      await createInstitution(institutionData);
      const updated = await listInstitutions();
      setInstitution(updated?.results || []);
    } catch (err) {
      console.error('Erro ao adicionar instituição:', err);
      toast.error('Erro ao adicionar instituição');
    }
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container">
        <Titulo
          children={<h2>Cursos</h2>}
          children2={
            <button className="btnAdcionar" onClick={() => setIsModalOpen(true)}>
              <img src={PlusCircle} alt='icone' /> Cadastrar Curso
            </button>
          }
        />

        <div className="content content-table ">
          <table className="tabela">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Módulo</th>
                <th>Duração</th>
                <th>Turno</th>
                <th>EAD</th>
                <th>Ativo</th>
              </tr>
            </thead>
            <tbody>
              {courses.map((course) => (
                <tr key={course.id}>
                  <td>{course.name}</td>
                  <td>{course.modulo}</td>
                  <td>{course.duration}</td>
                  <td>{course.shift}</td>
                  <td>{course.ead ? 'Sim' : 'Não'}</td>
                  <td>{course.active ? 'Ativo' : 'Inativo'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {isModalOpen && (
          <Modal
            isOpen={isModalOpen}
            closeModal={() => {
              setIsModalOpen(false);
              setFormData({
                name: '',
                modulo: '',
                duration: '',
                duration_hours: '',
                duration_minutes: '',
                ead: false,
                active: true,
                days: '',
                individual: false,
                shift: '',
                offeror: '',
                type_course: ''
              });
            }}
          >
            <h4>Cadastrar Curso</h4>
            <form onSubmit={handleSubmit}>
              <div className="form-group-large">
                <label>Nome</label>
                <input type="text" name="name" value={formData.name} onChange={handleInputChange} required />
              </div>
              <div className="form-group">
                <label>Módulo</label>
                <input type="text" name="modulo" value={formData.modulo} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Carga horária</label>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <input
                    type="number"
                    name="duration_hours"
                    value={formData.duration_hours || ''}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, duration_hours: e.target.value }))
                    }
                    placeholder="Horas"
                    min={0}
                    required
                  />
                  <input
                    type="number"
                    name="duration_minutes"
                    value={formData.duration_minutes || ''}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, duration_minutes: e.target.value }))
                    }
                    placeholder="Minutos"
                    min={0}
                    max={59}
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Turno</label>
                <select name="shift" value={formData.shift} onChange={handleInputChange} required>
                  <option value="">Selecione o turno</option>
                  <option value="Manhã">Manhã</option>
                  <option value="Tarde">Tarde</option>
                  <option value="Noite">Noite</option>
                </select>
              </div>
              <div className="form-group">
                <label>Dias</label>
                <input type="text" name="days" value={formData.days} onChange={handleInputChange} />
              </div>

              <div className="form-group container-quick-modal">
                <div className="form-group-lager">
                  <label>Instituição</label>
                  <select name="offeror" value={formData.offeror} onChange={handleInputChange} required>
                    <option value="">Selecione a escola</option>
                    {institution.map((unit) => (
                      <option key={unit.id} value={unit.id}>{unit.name}</option>
                    ))}
                  </select>
                </div>
                <QuickAddModal
                  label="Instituição"
                  fields={[
                    { name: 'name', placeholder: 'Nome', type: 'text' },
                    { name: 'cnpj', placeholder: 'CNPJ', type: 'number' },
                  ]}
                  onAdd={async (data) => await handleAddInstituition(data)}
                />
              </div>

              <div className="form-group">
                <label>Tipo de Curso</label>
                <select name="type_course" value={formData.type_course} onChange={handleInputChange} required>
                  <option value="">Selecione o tipo de curso</option>
                  {typeCourses.map((type) => (
                    <option key={type.id} value={type.id}>{type.name}</option>
                  ))}
                </select>
              </div>

              <div className='form-group-triplo'>
                <div>
                  <label>Ativo</label>
                  <input type="checkbox" name="active" checked={formData.active} onChange={handleInputChange} />
                </div>
                <div>
                  <label>EAD</label>
                  <input type="checkbox" name="ead" checked={formData.ead} onChange={handleInputChange} />
                </div>
                <div>
                  <label>Individual</label>
                  <input type="checkbox" name="individual" checked={formData.individual} onChange={handleInputChange} />
                </div>
              </div>
              <button type="submit" className="btnAcao" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </button>
            </form>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default Course;
